import { registerBlockType } from '@wordpress/blocks';
import { share as icon } from '@wordpress/icons';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: icon,
  },
});
